import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DYNAMIC_COMPONENT_CONFIG } from '../../../services/eui-dynamic-component.service';
import { EuiDialogService } from '../../eui-dialog';
import { EuiPickerItem } from '../models/eui-picker-item.model';

@Component({
    templateUrl: './eui-modal-picker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../styles/_index.scss'],
})
export class EuiModalPickerComponent implements OnInit, OnDestroy {

    public form: FormGroup;

    public dataSrc: EuiPickerItem[];
    public filteredData: EuiPickerItem[];

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(@Inject(DYNAMIC_COMPONENT_CONFIG) public config: any,
                private euiDialogService: EuiDialogService,
                private fb: FormBuilder) {}

    ngOnInit() {
        this.dataSrc = [...this.config.items];
        this.filteredData = [...this.config.items];

        this.form = this.fb.group({
            search: new FormControl(null),
        });

        this.form.get('search').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            this.filteredData = this.dataSrc.filter(data => data.label.toLowerCase().indexOf(value) !== -1);
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    toggleSelected(id: number) {
        const item = this.filteredData.find(f => f.id === id);

        this.dataSrc = this.dataSrc.map(f => f.id === id ? { ...f, isSelected: !item.isSelected } : f);
        this.filteredData = this.filteredData.map(f => f.id === id ? { ...f, isSelected: !item.isSelected } : f);

        if (item.isSelected) {
            this.config.itemsChange({
                added: item,
                removed: null,
                items: this.dataSrc,
                selected: this.dataSrc.filter(f => f.isSelected),
                unselected: this.dataSrc.filter(f => !f.isSelected),
            });
        } else {
            this.config.itemsChange({
                added: null,
                removed: item,
                items: this.dataSrc,
                selected: this.dataSrc.filter(f => f.isSelected),
                unselected: this.dataSrc.filter(f => !f.isSelected),
            });
        }
    }

    clearInput() {
        this.form.get('search').patchValue('');
    }

}
